import { useCallback, useMemo } from "react";

import type { VoucherForCampaignNewItem_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useInitMarketingCampaignFormModelContext } from "../../../init";
import { serverModelToInputModelConverter } from "./converter/server-model-to-input-model/server-model-to-input-model";
import { useCampaignEditMutation } from "../../../repository/new";
import { useNewCampaignPublish } from "../../../repository/new/mutation/use-campaign-publish-mutation.";

import type { MarketingNewCampaignFormModelContextType } from "../../../../ui/new/context/context";
import type { MarketingCampaignFormModel } from "../../../type";

type Props = {
	data: VoucherForCampaignNewItem_EditPageQuery;
	queryData: MarketingCampaignFormModel["QueryData"];
};

export const useInitialized = ({ data, queryData }: Props): MarketingNewCampaignFormModelContextType => {
	const inputModel = useMemo(() => serverModelToInputModelConverter(data), [data]);

	const { onSetViewModel, onResetViewModel, viewModel } = useInitMarketingCampaignFormModelContext({
		inputModel,
		queryData,
	});

	const { onSave: _onSave } = useCampaignEditMutation({ onResetViewModel });
	const { onPublish: _onPublish } = useNewCampaignPublish({ onResetViewModel });

	const onPublish = useCallback(() => {
		_onPublish(viewModel);
	}, [_onPublish, viewModel]);

	const onSave = useCallback(() => {
		_onSave({ ...viewModel });
	}, [_onSave, viewModel]);

	return {
		queryData,
		onSetViewModel,
		viewModel,
		onSave,
		onPublish,
	};
};
